import { BitrixVue } from 'ui.vue';
import '../../../select/select';
import '../../../doubleInput/doubleInputNumeric.js';
import '../../../swiper/Swiper.js';
import '../../../slider/simpleItemTop.js';
import '../../../colors/Color.js';
import '../../../slider/doorItem.js';

function filterDoors(arr, style, fabrika, price) {
	return arr.filter((item) => {
		if (item.price >= price[0] && item.price <= price[1]) {
			if (style.toLowerCase() == 'все'.toLowerCase() && fabrika.toLowerCase() == 'все') return item;
			if (style.toLowerCase() == 'все'.toLowerCase() && item.fabrika !== null && item.fabrika.toLowerCase() == fabrika.toLowerCase()) {
				return item;
			}
			if (fabrika.toLowerCase() == 'все' && item.style !== null && item.style.toLowerCase() == style.toLowerCase()) {
				return item;
			}
			if (item.style !== null && item.style.toLowerCase() == style.toLowerCase() && item.fabrika !== null && item.fabrika.toLowerCase() == fabrika.toLowerCase()) {
				return item;
			}
		}
	});
}
BitrixVue.cloneComponent('Step1', 'Steps', {
	data() {
		return {
			step1: {},
			selectedStyle: '',
			selectedFabrika: '',
			show: false,
			minMaxPrice: [],
			selectedDoorSize: null,
			requiredParams: {
				selectedDoor: null,
				selectedCover: null,
			},
			storeParams: {
				selectedDoor: null,
				selectedCover: null,
			},
			filteredArr: [],
		};
	},
	props: ['door', 'doorCover'],
	created() {
		this.getDataStep();
	},
	methods: {
		isShow() {
			return this.show;
		},
		setActiveDoor(index) {
			this.step1.doors.forEach((door) => {
				if (door.id === index) {
					this.step1.coverMaterial = door.colors;
				}
			});

			if (this.requiredParams.selectedDoor !== index) {
				this.requiredParams.selectedCover = null;
			}
			this.requiredParams.selectedDoor = index;
		},
		setSelectedStyle(value) {
			this.selectedStyle = value;
		},
		setSelectedFabrika(value) {
			this.selectedFabrika = value;
		},
		setMinMaxPriceValue(value) {
			this.minMaxPrice = value;
		},
		maxPrice(list) {
			let maxPrice = 0;
			maxPrice = list.reduce((a, b) => (a > Number(b.price) ? a : Number(b.price)), maxPrice);

			return maxPrice;
		},
		minPrice(list) {
			let minPrice = 0;
			minPrice = list.reduce((a, b) => (a < Number(b.price) ? a : Number(b.price)), minPrice);
			return minPrice;
		},
		getDataStep() {
			const context = this;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep1', { mode: 'class', method: 'post', data: { position: '' } });
			req.catch(function (response) {
			});
			req.then((response) => {
				if (response.status == 'success') {
					context.step1 = response.data.result;
					context.step1.colors = response.data.result.coverMaterial;
					context.step1.coverMaterial = [];
					context.filteredArr = [...response.data.result.doors];
					context.minMaxPrice = [this.minPrice(response.data.result.doors), this.maxPrice(response.data.result.doors)];
					context.selectedStyle = response.data.result.style[0];
					context.selectedFabrika = response.data.result.fabrika[0];
					context.show = true;
				}
				context.setDoorPreview(response.data.result.previewDoor);
			});
		},
		setDoorSize(value) {
			this.selectedDoorSize = value;
		},
	},
	computed: {
		hasArrayColors: function () {
			return this.step1.doors.filter((door) => {
				if (door.id === this.requiredParams.selectedDoor && door.colors.length) {
					return door.colors;
				}
			});
		},
	},
	watch: {
		'requiredParams.selectedDoor'(val, oldVal) {
			if (val !== undefined && val !== null) {
				this.storeParams.selectedDoor = this.step1.doors.filter((item) => {
					return item.id === val ? item : null;
				})[0];

				if (this.storeParams.selectedDoor.colors !== undefined && this.storeParams.selectedDoor.colors.length) {
					this.requiredParams.selectedCover = Number(this.storeParams.selectedDoor.colors[0].id);
				}
				const door = this.storeParams.selectedDoor;
				delete door.canvas;
				this.setPropPosition({
					door: door,
				});
				if (oldVal === null) return;
				if (Number(val.id) !== Number(oldVal.id)) {
					if (this.storeParams.selectedDoor.colors !== undefined && this.storeParams.selectedDoor.colors.length) {
						this.requiredParams.selectedCover = Number(this.storeParams.selectedDoor.colors[0].id);
					}
				}
			}
		},
		'requiredParams.selectedCover'(val, oldVal) {
			if (val === null) {
				this.setPropPosition({
					doorCover: null,
				});
				return;
			}

			this.storeParams.selectedCover = this.storeParams.selectedDoor.colors.filter((item) => {
				if (item !== null) return Number(item.id) === Number(val) ? item : null;
			})[0];

			this.setPropPosition({
				doorCover: this.storeParams.selectedCover,
			});
		},
		door(val) {
			if (val === undefined || val === null) {
				this.requiredParams.selectedDoor = null;
				this.requiredParams.selectedCover = null;
				this.storeParams.selectedDoor = null;
				this.storeParams.selectedCover = null;
				this.deletePositionKey(['door', 'doorCover']);
			}
		},
		filteredArr(val) {
			if (!val.length) {
				this.requiredParams.selectedDoor = null;
				this.requiredParams.selectedCover = null;
				this.setPropPosition({
					door: null,
					doorCover: null,
				});
			}
		},
		selectedStyle: function (val, oldVal) {
			this.filteredArr = filterDoors(this.step1.doors, val, this.selectedFabrika, this.minMaxPrice);
		},
		selectedFabrika: function (val, oldVal) {
			this.filteredArr = filterDoors(this.step1.doors, this.selectedStyle, val, this.minMaxPrice);
		},
		minMaxPrice: function (val, oldVal) {
			this.filteredArr = filterDoors(this.step1.doors, this.selectedStyle, this.selectedFabrika, val);
		},
	},
	template: `
	<div class="config-block">
		<div v-if="this.isShow()">
			<div class="config-block__wrap">
				<div class="config-block__wrap-title">Модель двери</div>
				<div class="config-door_model-params">
					<Select label="Коллекция" :options="step1.style" placeholder="Коллекция" :selected="step1.style[0]"
						v-on:selectSelectedValue="setSelectedStyle" />
					<Select label="Фабрика" :options="step1.fabrika" placeholder="Фабрика" :selected="step1.fabrika[0]"
						v-on:selectSelectedValue="setSelectedFabrika" />
					<DoubleInputNumeric label="Цена, руб." :minValue="minPrice(step1.doors)" :maxValue="maxPrice(step1.doors)"
						v-on:doubleInputValueChanged="setMinMaxPriceValue" />
				</div>
			</div>

			<div class="config-block__wrap mt-20">
				<Swiper class="door-slider" :basicSlidesPerView="1.5" :basicSpaceBetween="20" :breakpointsForSlides="3"
					v-if="filteredArr.length">
					<div class="swiper-slide" v-for="(slide, index) of filteredArr">
						<DoorItem :image="slide.image" :title="slide.title" :price="slide.price"
							:key="slide.id" :availability="slide.availability"
							:class="{active: Number(requiredParams.selectedDoor) === Number(slide.id)}" v-on:setActive="setActiveDoor(slide.id)"
							:activeDoor="requiredParams.selectedDoor" :doorId="slide.id" />
					</div>
				</Swiper>
				<div v-else style="display: flex;align-items: center;flex-direction: column;">
					<img src="/giper-config/assets/images/icon-error.png" alt="Дверей не найдено" style="max-width: 100px;" />
					<div style="margin-top: 30px; font-size: 20px; font-weight: bold; text-align: center;">Извините, двери с такими параметрами не
						найдены</div>
				</div>
				<!--<CatalogModal :items="step1.doors" />-->
			</div>

			<div class="config-block__wrap mt-48" v-if="requiredParams.selectedDoor !== null && hasArrayColors.length">
				<ConfigBlockWrapTitle>Цвет покраски</ConfigBlockWrapTitle>
				<div class="flex flex-wrap">
					<ConfigBlockColors>
						<Color v-for="(color, index) of hasArrayColors[0].colors" :color="color" :key="color.id"
							:class="{active: Number(requiredParams.selectedCover) === Number(color.id)}"
							v-on:setActiveColor="requiredParams.selectedCover = color.id" :data-id="color.id" v-if="color !== null"/>
					</ConfigBlockColors>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="config-block__wrap">
				<div class="config-block__wrap-title">Модель двери</div>
				<div class="config-door_model-params">
					<PuSkeleton height="75px" />
					<PuSkeleton height="75px" />
					<PuSkeleton height="75px" />
				</div>
			</div>
			<div class="config-block__wrap mt-20">
				<Swiper class="door-slider" :basicSlidesPerView="1.5" :basicSpaceBetween="20" :breakpointsForSlides="3">
					<div class="swiper-slide" v-for="(slide, index) of [1,2,3]">
						<PuSkeleton height="350px" />
					</div>
				</Swiper>
			</div>
		</div>
	</div>
	`,
});
